import React, { useState, useEffect, useRef } from "react";
import styles from "assets/scss/task_management.module.css";
import "assets/scss/style.css";
import { FaTimes } from "react-icons/fa";
import { Trans } from "react-i18next";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const UpdateGroup = ({ group, onClose, onSave, employees, selectedOrganisation, t }) => {
    const [groupName, setGroupName] = useState(group?.group_name || "");
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (group?.employees) {
            setSelectedEmployees(
                group?.employees?.map((employee) => ({
                    value: employee?.id,
                    label: employee?.full_name,
                }))
            );
        }
    }, [group]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSave = async () => {
        const updatedGroup = {
            ...group,
            group_name: groupName,
            employees: selectedEmployees.map(employee => employee.value).filter(Boolean),
            connected_organisation: selectedOrganisation.id,
            xero_organisation_id: selectedOrganisation.xero_organisation_id
        };
        await onSave(updatedGroup);
        onClose();
    };

    const handleEmployeeSelect = (employee, full_name) => {
        if (!selectedEmployees.some((e) => e.value === employee.id)) {
            setSelectedEmployees(prevSelected => [
                ...prevSelected,
                { value: employee, label: full_name },
            ]);
        }
    };

    const handleRemoveEmployee = (employeeId) => {
        setSelectedEmployees(prevSelected =>
            prevSelected.filter(employee => employee.value !== employeeId)
        );
    };

    const unselectedEmployees = employees.filter(employee =>
        !selectedEmployees.some(e => e.value === employee.id)
    );

    return (
        <Modal isOpen={!!group} toggle={onClose} size="md">
            <ModalHeader toggle={onClose}><Trans>Edit Group</Trans></ModalHeader>
            <ModalBody>
                <div className={styles.modalContent}>
                    <label><Trans>Group name</Trans>*</label>
                    <input type="text" value={groupName} onChange={(e) => setGroupName(e.target.value)} />

                    {selectedEmployees.length > 0 && (
                        <>
                            <div className={styles.assignedEmployees}><strong><Trans>Assigned Employees</Trans></strong></div>
                            {selectedEmployees.map((employee) => (
                                <div key={employee.value} className={styles.assignedEmployee}>
                                    {employee.label} <FaTimes onClick={() => handleRemoveEmployee(employee.value)} />
                                </div>
                            ))}
                        </>
                    )}
                    <label><Trans>Employee</Trans>*</label>

                    <div className={styles.notes_area}>
                        <input 
                            type="text" 
                            placeholder={t("Search Employees")}
                            value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                            className={styles.search_employee}
                            onFocus={() => setShowDropdown(true)}
                        />
                    </div>

                    {showDropdown && (
                        <div className={styles.dropdownContent} ref={dropdownRef}>
                            <div className={styles.suggestions}><strong><Trans>Suggestions</Trans></strong></div>
                            {unselectedEmployees ? unselectedEmployees
                                .filter(employee => employee?.full_name?.toLowerCase().includes(searchKeyword.toLowerCase()))
                                .map((employee, index) => (
                                    <button
                                        key={index}
                                        className={styles.suggestion}
                                        onMouseDown={() => {
                                            handleEmployeeSelect(employee?.id, employee?.full_name);
                                            setSearchKeyword("");
                                        }}
                                    >
                                        {employee?.full_name}
                                    </button>
                                ))
                            : <div className={styles.noSuggestions}><Trans>No results found</Trans></div>}
                        </div>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={onClose}><Trans>Cancel</Trans></Button>
                <Button color="primary" onClick={handleSave} disabled={!groupName || selectedEmployees?.length === 0}>
                    <Trans>Save</Trans>
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default UpdateGroup;